export interface NumberIntervalType {
  from: number | null;
  to: number | null;
}

export function isNumberIntervalType(value: unknown): value is NumberIntervalType {
  return typeof value === 'object' && value !== null && 'from' in value && 'to' in value;
}
